import React from "react";

export class DialogHandler {
  manageDialog(dialog) {
    this.managedDialog = dialog;
  }

  resolve(value) {
    this.managedDialog.toggleDialog();
    this._resolve(value);
  }

  reject(value) {
    this.managedDialog.toggleDialog();
    this._reject(value);
  }

  open = () => {
    const promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
    this.managedDialog.toggleDialog();
    return promise;
  };

  close = () => {
    if (this.managedDialog.state.isOpen) {
      this.managedDialog.toggleDialog();
    }
  }
}

export function controlledDialogHOC(WrappedDialog) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isOpen: false
      };
    }

    componentDidMount() {
      this.props.handler.manageDialog(this);
    }

    toggleDialog = () => {
      this.setState(prev => ({ isOpen: !prev.isOpen }));
    };

    render() {
      return (
        <WrappedDialog
          open={this.state.isOpen}
          onClose={() => this.props.handler.reject()}
          {...this.props}
        >
          {this.props.children}
        </WrappedDialog>
      );
    }
  };
}
